import type { CTA_BAND_DATA, CTA_BAND_PARAMS } from './types'
import { DEFAULT_BLOCK_LINK } from '../_shared/link/types'

export const DEFAULT_CTA_BAND_DATA = (): CTA_BAND_DATA => ({
  id: null,
  classes: null,
  styles: null,
  type: 'cta-band',
  title: 'Přestaň hledat. Začni vybírat.',
  subtitle: 'Databáze, ve které víš, kde co koupit, za kolik a proč to funguje.',
  ctaLabel: 'Chci vstoupit do klubu',
  ctaLink: DEFAULT_BLOCK_LINK(),
  data: { document: null, hash: null, size: 'xl', crop: 'structured-image-crop-none' },
})

export const DEFAULT_CTA_BAND_PARAMS = (): CTA_BAND_PARAMS => ({
  pc: { hidden: false },
  tablet: { hidden: false },
  mobile: { hidden: false },
})
